import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { getSpecNearbyListingsInfo } from 'constants/routes'
import { combineAndSortListings } from '../services/processSummaryCard';

/**
 * Retrieves additional marker information for a Spec nearby listings carousel.
 *
 * @param {Object} payload - The payload containing the spec Id.
 * @param {string} payload.id - The ID of the marker.
 * @returns {Observable} - An observable that emits the additional marker information.
 */
function getSpecNearbyListings(payload) {
  const url = `${getSpecNearbyListingsInfo}?specs=${payload.specIds}&plans=${payload.planIds}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'image/webp',
    }
  }).pipe(
    switchMap(async (response) => {
      const data = await response.json();
      const sortedListings = combineAndSortListings(data, payload.sortOrder);

      return sortedListings;
      
    })
  );
}

export default getSpecNearbyListings;